/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authresolvefailedclose3Inputs */



/**
* | output |
* | --- |
* | "Close" |
*
* @param {Authresolvefailedclose3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const authresolvefailedclose3 = /** @type {((inputs?: Authresolvefailedclose3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authresolvefailedclose3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Close")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar")
	return /** @type {LocalizedString} */ ("Закрыть")
});
export { authresolvefailedclose3 as "authResolveFailedClose" }